

export function bezier2D(t, c1, c2, c3, c4, v1, v2, v3, v4) {
    const bx = Math.pow(1 - t, 3) * c1
        + 3 * t * Math.pow(1 - t, 2) * c2
        + 3 * Math.pow(t, 2) * (1 - t) * c3
        + Math.pow(t, 3) * c4;

    const by = Math.pow(1 - t, 3) * v1
        + 3 * t * Math.pow(1 - t, 2) * v2
        + 3 * Math.pow(t, 2) * (1 - t) * v3
        + Math.pow(t, 3) * v4;
    return { x: bx, y: by };
}